import reduce from 'lodash/reduce';
import lodashGet from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import { sub, get } from './core';
import { TAG_NAME, CACHE_KEY_HIGHLIGHT_ENABLE, HIGHLIGHT_CHANNEL_IDENTITY } from './contants';
import { Store, getSelectorByKeywords } from './utils';
const cache = Store();
let styleNode;
let currentStructureStyle;
const tpl = ({ color, keywordOnAttr }) => `${TAG_NAME}${getSelectorByKeywords(keywordOnAttr)}{
        background-color:${color};
        color: black;
    }
    `;
export const clearStyles = () => {
    if (styleNode) {
        styleNode.innerHTML = '';
    }
};
export const createStyles = (namespace = 'default') => () => {
    // eslint-disable-next-line no-use-before-define
    if (!enable(namespace)()) {
        clearStyles();
        return;
    }
    if (!styleNode) {
        styleNode = document.createElement('style');
        styleNode.type = 'text/css';
        document.head.appendChild(styleNode);
    }
    const config = get();
    if (config.length === 0) {
        styleNode.innerHTML = '';
        return;
    }
    const content = reduce(config, (style, { color, keywordOnAttr }) => style + tpl({ color, keywordOnAttr }), `
        .patsnap-mark-current-focus {
            background-color: #ab8500 !important;
        }
        `);
    if (content !== styleNode.innerHTML) {
        styleNode.innerHTML = content;
    }
};
/**
 * 启用(或禁用)并返回是否启用高亮
 * @param {Boolean} config
 * @return {Boolean} enable
 */
export const enable = (namespace = 'default') => (bool) => {
    const key = `${namespace}:${CACHE_KEY_HIGHLIGHT_ENABLE}`;
    if (!isUndefined(bool)) {
        cache.set(key, { data: !!bool, id: HIGHLIGHT_CHANNEL_IDENTITY });
        if (!bool) {
            clearStyles();
        }
        else {
            createStyles(namespace)();
        }
    }
    return cache.get(key) ? lodashGet(cache.get(key), 'data') : true;
};
export const installHighlightStyle = (namespace = 'default') => {
    sub(createStyles(namespace));
};
export const updateCurrentStructureStyle = (id) => {
    if (!currentStructureStyle) {
        currentStructureStyle = document.createElement('style');
        currentStructureStyle.type = 'text/css';
        document.head.appendChild(currentStructureStyle);
    }
    currentStructureStyle.innerHTML = `
    [data-id="${id}"] {
        background-color: #FFF98A !important;
    }
    `;
};
//# sourceMappingURL=styles.js.map